<template>
  <div class="add_box">
    <el-card>
      <!-- 搜索&操作区 -->
      <div class="search_box">
        <div>
          <el-input
            v-model="searchName"
            style="width:200px;margin-right:10px"
            placeholder="请输入名称"
            @keyup.enter.native="handleSearch"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            @click="handleReset"
          >重置</el-button>
        </div>
        <div>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="openDialog('add')"
          >新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="book_id" label="短剧id" width="200" align="center" />
        <el-table-column prop="name" label="名称" width="200" align="center" />
        <el-table-column prop="image_url" label="图片" align="center" width="180">
          <template slot-scope="scope">
            <el-image
              style="width: 80px; height: 80px ;"
              :src="scope.row.thumb_uri"
              :preview-src-list="[scope.row.thumb_uri]"
              fit="cover"
            >
              <div slot="error" class="image-slot" />
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="标志"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-for="(tag, index) in scope.row.category"
              :key="index"
              type="info"
              size="mini"
              style="margin: 2px"
            >
              {{ tag }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="limit_date" label="截至时间" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDialog('edit', scope.row)">编辑</el-button>
            <el-button type="info" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        layout="prev, pager, next"
        style="margin-top: 20px; text-align: right"
        @current-change="handlePageChange"
      />
    </el-card>

    <!-- 弹窗 -->
    <el-dialog
      :title="dialogType === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="25%"
      :destroy-on-close="true"
    >
      <div>
        <el-form :model="dialogForm" label-width="80px">
          <el-form-item label="短剧id" required>
            <el-input v-model="dialogForm.book_id" />
          </el-form-item>
          <el-form-item label="名称" required>
            <el-input v-model="dialogForm.name" />
          </el-form-item>
          <el-form-item label="标志">
            <div style="display: flex; flex-wrap: wrap; gap: 5px;">
              <el-input
                v-model="categoryInput"
                placeholder="输入后回车添加标签"
                size="small"
                style="width: 100%"
                @keyup.enter.native="addCategory"
              />
              <el-tag
                v-for="(tag, index) in dialogForm.category"
                :key="index"
                closable
                @close="removeCategory(index)"
              >
                {{ tag }}
              </el-tag>
            </div>

          </el-form-item>
          <el-form-item label="截至时间" required>
            <el-date-picker
              v-model="dialogForm.limit_date"
              type="date"
              placeholder="请选择日期"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  hongguoList,
  addPlaylet,
  updatePlaylet,
  delPlaylet
} from '@/api/hongGuoPlaysLink'

export default {
  name: 'DramaListDemo',
  data() {
    return {
      searchName: '',
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,

      dialogVisible: false,
      dialogType: 'add',
      dialogForm: {
        name: '',
        book_id: '',
        limit_date: '',
        category: []
      },
      categoryInput: '',
      currentEditRow: null,
      loading: false
    }
  },
  mounted() {
    this.fetchTableData()
  },
  methods: {
    async fetchTableData() {
      this.loading = true
      try {
        const res = await hongguoList({
          name: this.searchName,
          page: this.currentPage,
          page_size: this.pageSize
        })
        if (res && res.data) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
        }
      } catch (e) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchTableData()
    },
    handleReset() {
      this.searchName = ''
      this.currentPage = 1
      this.fetchTableData()
    },
    openDialog(type, row = null) {
      this.dialogType = type
      this.dialogVisible = true

      if (type === 'edit' && row) {
        this.dialogForm = {
          id: row.id,
          name: row.name || '',
          book_id: row.book_id || '',
          limit_date: row.limit_date || '',
          category: Array.isArray(row.category) ? [...row.category] : []
        }
      } else {
        this.dialogForm = {
          name: '',
          book_id: '',
          limit_date: '',
          category: []
        }
      }

      this.categoryInput = ''
    },
    async handleDialogConfirm() {
      if (!this.dialogForm.book_id) {
        this.$message.warning('短剧id必填哦')
        return
      }
      if (!this.dialogForm.name) {
        this.$message.warning('名称必填哦')
        return
      }
      if (!this.dialogForm.limit_date) {
        this.$message.warning('截止时间必填哦')
        return
      }

      this.loading = true
      try {
        if (this.dialogType === 'add') {
          await addPlaylet(this.dialogForm)
          this.$message.success('新增成功')
        } else {
          await updatePlaylet({
            ...this.dialogForm,
            id: this.dialogForm.id
          })
          this.$message.success('编辑成功')
        }
        this.dialogVisible = false
        this.fetchTableData()
      } catch (e) {
        this.$message.error('操作失败 🥲')
      } finally {
        this.loading = false
      }
    },
    handleDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.loading = true
        try {
          await delPlaylet({ id: row.id })
          this.$message.success('删除成功')
          this.fetchTableData()
        } catch (e) {
          this.$message.error('删除失败 😭')
        } finally {
          this.loading = false
        }
      })
    },
    handlePageChange(page) {
      this.currentPage = page
      this.fetchTableData()
    },
    addCategory() {
      const tag = this.categoryInput.trim()
      if (tag && !this.dialogForm.category.includes(tag)) {
        this.dialogForm.category.push(tag)
      }
      this.categoryInput = ''
    },
    removeCategory(index) {
      this.dialogForm.category.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.image-slot {
  width: 80px;
  height: 80px;
  color: #ddd;
  text-align: center;
  line-height: 80px;
}
</style>
